__turbopack_context__.v({
  "className": "space_grotesk_6ae929e6-module__1befjW__className",
});
